<template>
  <v-container>
    <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes, validate }">
      <v-form ref="form">
        <VTextFieldWithValidation rules="required|max:150" v-model="user.name" :counter="150" label="Имя"/>
        <VTextFieldWithValidation rules="required|max:24|alpha_dash" v-model="user.username" :counter="24"
                                  label="Логин"/>
        <VTextFieldWithValidation rules="required|email" v-model="user.email" label="E-mail"/>
        <VTextFieldWithValidation rules="required|max:10" v-model="user.phone" label="Телефон"/>
        <VTextFieldWithValidation rules="required|max:10" v-model="user.skype" label="Скайп"/>
        <div class="text-sm-left text-sm-center">
          <v-btn
            depressed
            color="primary"
            @click="validate"
            :loading="isLoading"
            :disabled="invalid || !validated"
          >
            Сохранить
          </v-btn>
        </div>
      </v-form>
    </ValidationObserver>
    <v-snackbar
      color="success"
      :timeout="5000"
      :bottom="true"
      v-model="success"
    >
      Изменения сохранены.
      <v-btn flat icon @click.native="success = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { ValidationObserver, extend } from 'vee-validate'
import VTextFieldWithValidation from '../inputs/VTextFieldWithValidation'
import { required, email, max } from 'vee-validate/dist/rules'

extend('required', {
  ...required
})

extend('max', {
  ...max,
  message: 'This field must be {length} characters or less'
})

extend('email', {
  ...email
})

export default {
  name: 'Settings',
  components: {
    ValidationObserver,
    VTextFieldWithValidation
  },
  data () {
    return {
      success: false,
      valid: true,
      isLoading: false,
      user: {
        username: '',
        name: '',
        email: '',
        phone: '',
        skype: ''
      },
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 5) || 'Name must be less than 10 characters'
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      lazy: false
    }
  },
  computed: {},
  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    }
  },
  async mounted () {
  }
}
</script>

<style scoped>

</style>
